import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.css']
})
export class IntroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  redirectToFb(): void {
    window.open("https://www.facebook.com/pages/Seng-Hin-Rubber-M-Sdn-Bhd/421439151296044", "_blank");
  }

  redirectToLink(): void {
    window.open("https://www.linkedin.com/in/lee-seng-pin-28ba90129/?originalSubdomain=my", "_blank");
  }

}
